import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import settingField from 'components/Fields/ReduxForm/SettingField';
import styles from './ItemInventoryAlertField.css';

class ItemInventoryAlertField extends React.Component {
  render() {
    const { member, isEditable } = this.props;
    return (
      <div className="mk-grouped-input">
        <div className="form-group col-sm-8">
          <Field
            component="input"
            disabled
            name={`${member}.name`}
            className={`form-control ${!isEditable ? '' : styles['bg-white']}`}
          />
        </div>
        <div className="form-group col-sm-4">
          <Field
            component={settingField}
            positiveNumberOnly
            maxFractionDigits={3}
            dis={!isEditable}
            name={`${member}.in_stock`}
            inputClassName="text-right"
          />
        </div>
      </div>
    );
  }
}

ItemInventoryAlertField.propTypes = {
  member: PropTypes.string,
};

export default ItemInventoryAlertField;
